import { rd, RemoteData } from '@passionware/monads';
import { ensureError } from '@passionware/platform-js';
import { forwardRef, ReactNode } from 'react';
import { focusRings } from 'v5/design-system/_common/focusRing';
import { Skeleton } from 'v5/design-system/Skeleton';
import { cn } from 'v5/platform/dom/cn';

export interface EntityHeaderSubtitleProps {
  subtitle: RemoteData<ReactNode>;
}

export const EntityHeaderSubtitle = ({
  subtitle
}: EntityHeaderSubtitleProps) => {
  return (
    <div className="text-fg-muted text-base">
      {rd
        .journey(subtitle)
        .wait(<Skeleton className="w-40 h-lh" />)
        .catch(error => <div className="">{ensureError(error).message}</div>)
        .map(subtitle => subtitle)}
    </div>
  );
};

export const EntityHeaderSubtitleButton = forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<'button'>
>(({ children, className, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        focusRings.focus.visible,
        '-my-1.5  text-fg-muted font-light rounded-sm',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
});
